import { connectChat, disconnectChat } from '@/services/channel-service';
import { UPDATE_CHAT_STATUS } from '@/store/mutation-types';
import ResponseConnectionErrorChannel from '@/shared/utils/errors/ResponseConnectionErrorChannel';
import { handleError } from '@/shared/utils/promise-helpers';

const actions = {
  connectChat({}, agentId) {
    connectChat(agentId)
      .then()
      .catch((err) => {
        const {
          response: { data },
        } = err;

        if (data) throw new ResponseConnectionErrorChannel(data, 'chat');
      })
      .catch(handleError);
  },

  disconnectChat({ dispatch }, agentId) {
    disconnectChat(agentId)
      .then(console.log)
      .catch(() => {
        const alert = {
          text: 'errorDisconnectChannel',
          type: 'error',
        };

        dispatch('showSnackbar', alert, { root: true });
      });
  },

  connectedChat({ commit, dispatch }) {
    commit(UPDATE_CHAT_STATUS, 'available');
  },

  disconnectedChat({ commit, dispatch }) {
    commit(UPDATE_CHAT_STATUS, 'disconnected');
    dispatch(
      'showSnackbar',
      { text: 'channelChat.logoff', type: 'success' },
      { root: true },
    );
  },

  updateStatusChat({ dispatch }, status) {
    dispatch('updateChatStatus', status);
  },

  updateChatStatus({ commit }, newStatus) {
    commit(UPDATE_CHAT_STATUS, newStatus);
  },
};

export default actions;
